export const COMMON_CONSTANTS = {
  MIN_WRITE_PROGRESS: 10,
};



// WEBPACK FOOTER //
// ./src/constants/common.ts